import React, { Fragment } from "react";
import { ClusterWrapper, ClusterInnerWrapper } from "./Cluster.styled";
import { safeChildren } from "../../../util/general";

/*
  Cluster components suit any groups of elements that differ in
  length and are liable to wrap. Buttons that appear together at the
  end of forms are ideal candidates, as well as lists of tags
  keywords, or other meta information. Use the Cluster to align any
  groups of horizontally laid out elements to the left or right, or
  in the center.
*/

const Cluster = ({
  justify,
  align,
  childGap,
  minHeight,
  minWidth,
  nowrap,
  overflow = false,
  justifySelf,
  alignSelf,
  flexGrow,
  extraStyles,
  children,
  innerWrapperAs = "div",
  ...rest
}) => (
  <ClusterWrapper
    overflow={overflow}
    {...rest}
    $justifySelf={justifySelf}
    $alignSelf={alignSelf}
    $flexGrow={flexGrow}
    $extraStyles={extraStyles}
  >
    <ClusterInnerWrapper
      justify={justify}
      align={align}
      childGap={childGap}
      minHeight={minHeight}
      minWidth={minWidth}
      $nowrap={nowrap}
      as={innerWrapperAs}
    >
      {safeChildren(children, <Fragment />)}
    </ClusterInnerWrapper>
  </ClusterWrapper>
);

export default Cluster;
